<template>
	<div class="form">
		<div class="delete" v-if="canDelete" @click="confirm"></div>

		<b-form-row>
			<b-col cols="12">
				<input-component
					name="fullName"
					label="Nome completo"
					:required="true"
					v-model="fullName"
					v-if="!hideFullName"
					maxlength="255" />
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-col cols="12" :md="mustDivideLayout ? '6' : '12'">
				<input-component
					name="email"
					label="E-mail"
					:required="isEmailRequired"
					:check="true"
					class="mb-0"
					v-model="email"
					v-if="!hideEmail"
					maxlength="255" />
			</b-col>

			<b-col cols="12" :md="mustDivideLayout ? '6' : '12'">
				<input-component
					name="url"
					label="URL"
					:required="isUrlRequired"
					:check="true"
					class="mb-0"
					v-model="url"
					v-if="showUrl"
					maxlength="255" />
			</b-col>

			<b-col cols="12" :md="mustDivideLayout ? '6' : '12'">
				<input-component
					v-if="!hidePhone"
					name="phone"
					label="Telefone com DDD"
					:required="true"
					:check="true"
					:mask="phone.length > 14 ? '(##) #####-####' : '(##) ####-####'"
					class="mb-0"
					v-model="phone"
					maxlength="20" />
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
import { email, minLength, required, requiredIf } from "vuelidate/lib/validators";
import InputComponent from "@/components/Form/Inputs/InputComponent";

export default {
	name: "ContactFormComponent",
	props: { formKey: Number, canDelete: Boolean, hideFullName: Boolean, hideEmail: Boolean, hidePhone: Boolean, showUrl: Boolean, salesforceContactId: String },
	components: {
		InputComponent,
	},
	mounted() {
		if (!this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].email) {
			return;
		}

		this.$v.$touch();
	},
	methods: {
		/**
		 * Confirma a exclusão do contato
		 */
		confirm() {
			this.$store.commit("setConfirmForm", {
				form: this.onlyKeyName,
				key: this.formKey,
				salesforceContactId: this.salesforceContactId,
				formKey: this.formKey,
			});

			this.$bvModal.show("modal-confirm");
		},
	},
	computed: {
		/**
		 * Verifica se o layout deve ser dividido em duas colunas
		 */
		mustDivideLayout() {
			let count = 0;

			if (this.hideFullName === true) {
				count++;
			}

			if (this.hideEmail === true) {
				count++;
			}

			if (this.hidePhone === true) {
				count++;
			}

			return count > 2;
		},
		onlyKeyName() {
			return this.$vnode.key.replace(/[0-9]/g, "");
		},
		fullName: {
			get() {
				return this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].fullName;
			},
			set(value) {
				this.$store.commit("setContactData", {
					key: "fullName",
					form: this.onlyKeyName,
					index: this.formKey,
					value,
				});
			},
		},
		email: {
			get() {
				return this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].email;
			},
			set(value) {
				this.$store.commit("setContactData", {
					key: "email",
					form: this.onlyKeyName,
					index: this.formKey,
					value,
				});
			},
		},
		phone: {
			get() {
				return this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].phone;
			},
			set(value) {
				this.$store.commit("setContactData", {
					key: "phone",
					form: this.onlyKeyName,
					index: this.formKey,
					value,
				});
			},
		},
		url: {
			get() {
				return this.$store.state.form.ownersAndContacts[this.onlyKeyName][this.formKey].url;
			},
			set(value) {
				this.$store.commit("setContactData", {
					key: "url",
					form: this.onlyKeyName,
					index: this.formKey,
					value,
				});
			},
		},
		isEmailRequired() {
			// Se o campo URL estiver preenchido, o campo e-mail não é obrigatório
			return !this.hideEmail && this.showUrl ? !this.url : true;
		},
		isUrlRequired() {
			// Se o campo e-mail estiver preenchido, o campo URL não é obrigatório
			return this.showUrl ? !this.email : true;
		},
	},
	validations() {
		let validationObject = {};

		if (!this.hideFullName) {
			validationObject.fullName = {
				required,
			};
		}

		if (!this.hidePhone) {
			validationObject.phone = {
				required,
				minLength: minLength(14),
			};
		}

		// Se tiver que mostrar tanto o input de e-mail quanto o input de URL, a obrigatoriedade é de apenas um
		if (!this.hideEmail && this.showUrl) {
			validationObject.email = {
				required: requiredIf(function (validationTarget) {
					// Se o campo URL estiver preenchido, o campo e-mail não é obrigatório
					return !validationTarget.url;
				}),
				email,
			};

			validationObject.url = {
				required: requiredIf(function (validationTarget) {
					// Se o campo e-mail estiver preenchido, o campo URL não é obrigatório
					return !validationTarget.email;
				}),
			};
		} else {
			if (!this.hideEmail) {
				validationObject.email = {
					required,
					email,
				};
			}

			if (this.showUrl) {
				validationObject.url = {
					required,
				};
			}
		}

		return validationObject;
	},
};
</script>

<style lang="scss">
.form {
	border-radius: 8px;
	border: 2px solid #e7e7e7;
	padding: 40px 40px 15px 40px;
	margin: 20px 0;
	position: relative;
}

.delete {
	content: " ";
	top: -10px;
	right: -10px;
	width: 25px;
	z-index: 99;
	height: 25px;
	position: absolute;
	border-radius: 50%;
	background-color: #ed5417;
	cursor: pointer;
}

.delete::after {
	content: "−";
	color: white;
	position: absolute;
	font-weight: bold;
	margin-left: 0.45rem;
	margin-top: 0.1rem;
}
</style>
